import * as React from 'react';
import * as ReactDom from 'react-dom';
import { ReeferCommandsGrid } from '../../childcomponents/ReeferCommandsGrid';
import { PopupWindow } from '../../sharedcomponents/PopupWindow';
import { RCUtils } from '../../../RCUtils';
import $ from 'jquery';
var Config: any = require('../../../Config.json');

interface VCCheckBoxData {
    enableVCCheckBox: boolean;
    disableVCCheckBoxOption: boolean;
    disableVCDropDown: boolean;
    disableVCOption: boolean;
    selectedVCData: server.VesselInformation;
    dropDownVCData: server.VesselInformation[];
    isVCMessage: boolean;
}
const emptyVCCheckBoxData: VCCheckBoxData = { enableVCCheckBox: false, disableVCCheckBoxOption: false, disableVCDropDown: false, disableVCOption: false, selectedVCData: null, dropDownVCData: [], isVCMessage: false };

export interface IntelligentPTIFunctionGridState {
    SelectedReefers: any[];
    TempValue: string;
    RowData: server.USP_UnitCurrentConditionUI_Model[];
    Filters: server.ForwardCommandParameters;
    VCCheckBoxInfo: VCCheckBoxData; 
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
}
export class IntelligentPTIFunction extends React.Component<any, IntelligentPTIFunctionGridState> {
    constructor(props: any) {
        super(props);
        $('#globalLoader').show();
        var filterSet = this.setDefaultFilters();
        var selectReefer = [];
        this.state = { SelectedReefers: selectReefer, TempValue: "Off", RowData: [], Filters: filterSet, VCCheckBoxInfo: emptyVCCheckBoxData, IsCommandIssued: false, PrevSelectedItems: [] };        
    }

    componentDidMount() {
        if (this.props.reeferData != null && this.props.reeferData.length > 0) {
            this.setState({ RowData: this.props.reeferData });
            this.renderIntelligentPTIFunctionGrid(this.props.reeferData);
        }
        if (this.props.VCCheckBoxInfo != undefined && this.props.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: this.props.VCCheckBoxInfo });
        }
        $('#globalLoader').hide();
    }

    submitIntelligentPTIFunction() {
        var command = "IntelligentPTIFunction";
        var paramValue = this.state.TempValue;
        // if (paramValue != "" && paramValue != null) {
        var refreshGrid = this.props.refreshGrid;
        ReeferCommandsGrid.submitTemperatureCommands(command, paramValue, refreshGrid);
        this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
        //}
        //else
        //    PopupWindow.showErrorMessage("Alert", "Please enter valid Setpoint value.");
    }

    componentWillReceiveProps(nextprops: any) {
        var reeferData = nextprops.reeferData;
        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            $('#globalLoader').show();
            this.renderIntelligentPTIFunctionGrid(reeferData);
        }
        if (nextprops.VCCheckBoxInfo != undefined && nextprops.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: nextprops.VCCheckBoxInfo });
        }
    }

    renderIntelligentPTIFunctionGrid(reeferData: any) {
        this.state.Filters.CommandName = "IntelligentPTIFunction";
        this.state.Filters.SelectedReefers = reeferData;
        this.setState({ RowData: reeferData, TempValue: "Off" });
        var forwardCommandParams = JSON.stringify(this.state.Filters);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetForwardCommandData', { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.USP_UnitCurrentConditionUI_Model[]>)
            .then(data => {
                this.setState({ RowData: data });
                $('#globalLoader').hide();
            });
    }
    IntelligentPTIFunctionChange(event: React.FormEvent<HTMLSelectElement>) {
        var Value: string = event.currentTarget.value.trim();
        var filters = this.state.Filters;
        this.setState({ TempValue: Value });
    }

    setDefaultFilters() {
        var filters: server.ForwardCommandParameters = {
            SelectedReefers: [], CommandName: "IntelligentPTIFunction", TempValue: "Off", OtherValue: null, IsCmdSendViaVC: null, VesselInfo: null
        };

        return filters;
    }
    UpdateVCCheckBoxInfo(VCInfo: any) {
        if (this.props.UpdateVCCheckBoxInfo != null && this.props.UpdateVCCheckBoxInfo != 'undefined')
            this.props.UpdateVCCheckBoxInfo(VCInfo);
    } 

    public render() {
        return <div>
            <div>
                <div className="well DimiSettings">
                    <div className='col-md-6'>
                        <div className='row'>
                            <div className='col-md-6 pe-0 text-md-end'>
                                <label className='col-form-label'>Intelligent PTI Function :</label>
                            </div>
                            <div className='col-md-6'>
                                <select className='form-select' id='cmbIntelligentPTIFunction' onChange={e => this.IntelligentPTIFunctionChange(e)} value={this.state.TempValue}>
                                    <option key="OFF">Off</option>
                                    <option key="DIPTI">DIPTI</option>
                                    <option key="DIMI">DIMI</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <ReeferCommandsGrid reeferFormatter={this.props.reeferFormatter} selectedReefers={this.state.RowData} commandName={"IntelligentPTIFunction"} VCCheckBoxInfo={this.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={this.UpdateVCCheckBoxInfo.bind(this)}></ReeferCommandsGrid>
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" className="btn btn-primary" onClick={this.submitIntelligentPTIFunction.bind(this)}>Save</button>
            </div>
        </div>
    }
}